import { LockStatuses } from '../../constants/LockStatuses';
import { Subscription, Observable } from 'rxjs';
import { TranslationService } from '../services/translation-service.service';
import { OnInit } from '@angular/core';
import { LockService } from '../services/lock-service.service';

export enum LockingStrategy {
    /**The item will not be locked*/
    NoLocking = 0,

    /**Locks one item. The generateReuestPayload() should return one item. Overwrites are available on this Strategy*/
    LockEntireForm = 1,

    /**Locks multiple items. The generateReuestPayload() should return multiple items. Overwrites are not available on this Strategy*/
    LockItemsOnList = 2
}

export enum EditingStrategy {
    /**Goes into edit mode by pressing the Edit button.*/
    OnEditButtonPress = 1,

    /**Goes into edit mode automatically after the item is loaded (That's when afterItemLoad(lock) is invoked).*/
    AfterLoading = 2
}

export enum UnlockingStrategy {
    /**The lock will be destroyed and the form goes into view mode after saving (When afterSave(lock) is invoked).*/
    AfterSave = 1,

    /**Nothing happens after saving (When afterSave(lock) is invoked) The lock continues normally.*/
    Manually = 2
}

export class LockableItem {
    constructor(private ID: any, private SaveDate: any) {
        
    }
}

export class LockablePayload {
    constructor(private Items: any, private LockToken: string, private LockMode: LockStatuses, private OverwriteRequest:boolean, private LockProps: any) {
        
    }
};

export class ServerLockDetails {
    LockStatus: number;
    SecondsRemainingToRelease: number;
    LockedByUserFulleName: string;
    //LockDate: Date;
    AllowOverwrite: boolean;
    LockToken: string;
}

export interface LockableProps {
    editingStrategy(): EditingStrategy;
    lockingStrategy(): LockingStrategy;
    unlockingStrategy(): UnlockingStrategy;
    generateReuestPayload(): LockableItem[];
    invokeLockingEndpoint: (lock: Lock, lockMode: LockStatuses, overwrite: boolean) => Observable<ArrayBuffer>;

    /**Only required if LockingStrategy = LockItemsOnList when the lock is performed on the item instead the form */
    locateLockableItem(itemId: any): any;
    getTranslationService(): TranslationService;

    component: OnInit
}

export interface LockableComponent {
    lock: Lock;
};

export class Lock {
    lastLockRequest: Subscription = null;
    lastLockDetails: ServerLockDetails;
    locked: boolean = false;
    lockToken: string = null;
    lockedBy: string = null;
    noConnection: boolean = false;
    expired: boolean = false;
    saving: boolean = false;
    viewMode: boolean = true;
    goingToEdit: boolean = false;
    destroyed: boolean = false;
    lockableProps: LockableProps;

    constructor(_locakbleFunctions: LockableProps) {
        this.lockableProps = _locakbleFunctions;
    }

    public getLockablePropsPayload(): any {
        return {
            LockToken: this.lockToken,
            EditStrategy: this.lockableProps.editingStrategy(),
            UnlockStrategy: this.lockableProps.unlockingStrategy(),
            LockStrategy: this.lockableProps.lockingStrategy()
        };
    }
}